import React from "react";
import TopSection from "./TopSection";
import MenuBar from "./MenuBar";

const MainController = () => {
    return(
        <div className="bg-grey">
            <TopSection />
            <div className="dekho"></div>
            <div className="mainController">
                <MenuBar />
            </div>
        </div>
    );
};

export default MainController;